// extracted by css-extract-rspack-plugin
export default {"container":"_5109ab9e"};